import { render, staticRenderFns } from "./RailwayInfoCard.vue?vue&type=template&id=ef631786"
import script from "./RailwayInfoCard.vue?vue&type=script&lang=js"
export * from "./RailwayInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports